import React from 'react';
import {FormattedMessage} from 'react-intl';
import {oneOfType, string, bool, number, element} from 'prop-types';
import BasicAccordion from './BasicAccordion';

export default class AccordionSectionWrapper extends React.Component {
  static propTypes = {
    active: bool,
    animate: bool,
    index: oneOfType([string, number]),
    header: oneOfType([string, element]),
    headerKey: string,
    sectionKey: string
  };

  static defaultProps = {
    animate: true
  };

  constructor(props) {
    super(props);
    this.state = {
      open: props.active
    };
  }

  toggleOpen = () => {
    this.setState({open: !this.state.open});
  };

  get header() {
    return this.props.header || <FormattedMessage id={this.props.headerKey} />;
  }

  render() {
    return this.props.children.length && (
      <BasicAccordion
        id={this.props.sectionKey}
        className={this.props.className}
        header={this.header}
        index={this.props.index}
        active={this.state.open}
        animate={this.props.animate}
        onClick={this.toggleOpen}>
        {this.props.children}
      </BasicAccordion>
    );
  }
};



// WEBPACK FOOTER //
// ./public/components/common/AccordionSectionWrapper.jsx